import { useContext } from "react";
import { BottomSheet } from "react-spring-bottom-sheet";
import { useMediaQuery } from "iuvity-ui-components/dist/hooks";
import { LoginForm } from "./LoginForm";
import LoginMenuLanguage from "./extras/LoginLanguage";
import LoginSkeleton from "./extras/LoginSkeleton";
import { LIGHT_LOGIN_SVG } from "../../constants";
import { AppContext } from "../../context/index";
import styles from "./login.module.scss";

export const Login = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isMobileSM = useMediaQuery("(max-width: 480px)");

  const { t, appState: { isLoading } } = useContext(AppContext);

  const renderTemplate = () => {
    return (
      <div className={styles.loginFormContainer}>
        <div className={styles.loginForm}>
          {!isMobile && (
            <img
              src={LIGHT_LOGIN_SVG}
              alt="border-svg"
              className={styles.borderSVG}
            />
          )}
          <div className={styles.headerForm}>
            <h1 className={styles.channel}>
              {t('Login.appTitle')}
            </h1>
            <LoginMenuLanguage />
          </div>

          <div
            className={`${styles.formContainer} animate__animated animate__fadeIn`}
          >
            <h2 className={styles.formTitle}>{t("Login.loginTitle")}</h2>
            
            {
              isLoading ? <LoginSkeleton /> : <LoginForm />
            }
            
            {/*
            Commnented until future implementation on 2023.Q1
            <div className={styles.formLinks}>
              <Button
                variant="p-button-link"
                label={t("Login.forgotPasswordLink")}
                id="ForgotPasswordLink"
                onClick={() => {
                  window.location.href = `https://todo1.modyo.be/FRETUSER/RegeneratePassword?lang=es}`;
                }}
              />
            </div>
              */}

          </div>
          {/*
          Commented until we have defined Terms & Conditions
          <div className={styles.footer}>
            <CustomLink
              key="terms"
              content={t("Login.termsConditionsLabel")}
              href="https://www.todo1services.com/"
            />
          </div>
            */}
        </div>
      </div>
    );
  };

  return (
    <>
      {isMobile ? (
        <BottomSheet
          open={true}
          blocking={false}
          snapPoints={({ maxHeight, minHeight }) => [
            minHeight,
            isMobileSM ? maxHeight / 5.5 : maxHeight / 8,
          ]}
        >
          {renderTemplate()}
        </BottomSheet>
      ) : (
        renderTemplate()
      )}
    </>
  );
};
